import React, { useState } from "react";
import swal from "sweetalert";
import { NewsletterContainer, NewsletterForm, NewsletterInput, NewsletterButton, BellIcon } from "./newsletterBarElements";
import { useTranslation } from "react-i18next";

const NewsletterSection = () => {
  const { t } = useTranslation();
  const [status, setStatus] = useState( t('newsletterSub.txt'));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(t('newsletterSending.txt'));
    const { email } = e.target.elements;
    let details = {
      email: email.value,
    };
    let response = await fetch("/api/newsletter", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      body: JSON.stringify(details),
    });

    setStatus(t('newsletterSub.txt'));
    let result = await response.json();
    //using sweet alert for beuty
    if (result.status === "SUCCESS") {
      swal({
        icon: "success",
        title: t('newsletterSuccessTitle.txt'),
        text: t('newsletterSuccessText.txt'),
      });
    } else {
      swal({
        icon: "error",
        title: t('newsletterErrorTitle.txt'),
        text: t('newsletterErrorText.txt'),
      });
    }
  };

  return (
    <NewsletterContainer>
      <NewsletterForm onSubmit={handleSubmit} action="#">
        <NewsletterInput type="email" id="email" required />
        <NewsletterButton type="submit">
          <BellIcon />
          {status}
        </NewsletterButton>
      </NewsletterForm>
    </NewsletterContainer>
  );
};

export default NewsletterSection;
